import React, { useEffect, useState } from "react";

const SavedTabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Summary", "Error Details", "Rule Catalogue"];
  const [productName, setProductName] = useState("");

  useEffect(() => {
    const name = localStorage.getItem("selectedProductName");
    if (name) {
      setProductName(name);
    }
  }, []);

  return (
    <div className="tabs-container">
      {/* Left side title */}
      <div className="tabs-title">
        {productName ? `${productName} ` : "Product Report"}
      </div>

      {/* Right side: tabs only (no Save/Share) */}
      <div className="flex items-center gap-4">
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SavedTabs;
